document.addEventListener('alpine:initialized', () => {
  const metafieldRawEl = document.getElementById('dispatch-eta-data');
  let metafieldRaw = null;

  if (metafieldRawEl) {
    try {
      const parsedMetafieldRawEl = JSON.parse(metafieldRawEl.textContent);
      metafieldRaw = (typeof parsedMetafieldRawEl === 'string') ? JSON.parse(parsedMetafieldRawEl) : parsedMetafieldRawEl;
    } catch (e) {
      console.error('dispatch_eta parse failed', e);
    }
  }

  // ---- Date helpers (same logic as cart-eta.js, scoped locally) ----
  function getTodayISO() {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  function isDateInPast(isoDate) {
    return isoDate < getTodayISO();
  }

  const variantInput = document.querySelector('[name="id"]');
  const quantityInput = document.querySelector('[name="quantity"]');
  const form = document.querySelector('form[action^="/cart/add"]');
  const etaDisplayTarget = document.querySelector('.dispatch-eta-display');

  // Silent no-op if anything isn't present (keeps your current stable behavior)
  if (!metafieldRaw || !variantInput || !quantityInput || !form || !etaDisplayTarget) return;

  // ---- TUNABLES ----
  const LOW_STOCK_BUFFER = 3;              // if in-stock-now band has <= this many units, show Low Stock immediately
  const LOW_STOCK_MIN_BAND_WIDTH = 3;      // apply "last N units" rule when band is at least this wide
  const IN_STOCK_DAY_WINDOW = 5;           // band-0 is "In Stock" only if ETA is within this many WORKING days (non-OILED)
  const OILED_SWITCH_TO_MESSAGE_DAYS = 10; // OILED: show Pre-order until ETA is within 10 days

  // Render using your existing styled markup (CSS hooks stay intact)
  function renderInventoryStatusHTML(message, state) {
    // state: "instock" | "lowstock" | "preorder" | "mto" | "oiled"
    return `
      <div class="inventory-in-stock-status flex items-center mb-5" data-inventory-state="${state}">
        <span class="flex h-3 w-3 relative mr-2 rtl:mr-0 rtl:ml-2">
          <span class="inventory-status animate-ping absolute inline-flex h-full w-full rounded-full opacity-75" data-inventory-state="${state}"></span>
          <span class="inventory-status relative inline-flex rounded-full h-3 w-3" data-inventory-state="${state}"></span>
        </span>
        <div>${message}</div>
      </div>
    `;
  }

  // Format "YYYY-MM-DD" -> "25th Mar 2026" (timezone-safe; no Date parsing)
  function formatDateWithOrdinal(isoDate) {
    if (!isoDate) return "";

    const parts = isoDate.split("-");
    if (parts.length !== 3) return "";

    const year = parseInt(parts[0], 10);
    const monthIndex = parseInt(parts[1], 10) - 1;
    const day = parseInt(parts[2], 10);

    if (isNaN(year) || isNaN(monthIndex) || isNaN(day) || monthIndex < 0 || monthIndex > 11) return "";

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    function ordinal(n) {
      const mod100 = n % 100;
      if (mod100 >= 11 && mod100 <= 13) return n + "th";
      const mod10 = n % 10;
      if (mod10 === 1) return n + "st";
      if (mod10 === 2) return n + "nd";
      if (mod10 === 3) return n + "rd";
      return n + "th";
    }

    return ordinal(day) + " " + months[monthIndex] + " " + year;
  }

  // Pre-order message builder (date included)
  function preorderMessage(isoDate) {
    const formatted = formatDateWithOrdinal(isoDate);
    if (!formatted) return "Pre-order - Reserve now";
    return "Pre-Order Est. " + formatted + " - Reserve Now";
  }

  // Timezone-safe day diff using UTC midnights, based on ISO string
  function parseISOToUTCDate(iso) {
    if (!iso) return null;
    const parts = iso.split("-");
    if (parts.length !== 3) return null;

    const y = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10) - 1;
    const d = parseInt(parts[2], 10);

    if (isNaN(y) || isNaN(m) || isNaN(d) || m < 0 || m > 11) return null;
    return new Date(Date.UTC(y, m, d));
  }

  function daysFromTodayUTC(iso) {
    const dt = parseISOToUTCDate(iso);
    if (!dt) return null;

    const now = new Date();
    const todayUTC = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    const ms = dt.getTime() - todayUTC.getTime();
    return Math.round(ms / 86400000);
  }

  // working-day diff (Mon–Fri), timezone-safe using UTC
  function businessDaysFromTodayUTC(iso) {
    const target = parseISOToUTCDate(iso);
    if (!target) return null;

    const now = new Date();
    const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));

    // If target is today or in the past, treat as 0 days away
    if (target.getTime() <= today.getTime()) return 0;

    let count = 0;
    const cursor = new Date(today.getTime());

    // Count business days from tomorrow up to (and including) the target date
    while (cursor.getTime() < target.getTime()) {
      cursor.setUTCDate(cursor.getUTCDate() + 1);
      const dow = cursor.getUTCDay(); // 0=Sun ... 6=Sat
      if (dow !== 0 && dow !== 6) {
        count++;
      }
    }
    return count;
  }

  function resolveETA(variantId, qty) {
    for (const sku in metafieldRaw) {
      const entry = metafieldRaw[sku];
      if (entry && entry.variant_id == variantId) {
        const ranges = entry.ranges || [];
        for (let i = 0; i < ranges.length; i++) {
          const r = ranges[i];
          if (qty >= r.min && qty <= r.max) {
            return {
              date: r.eta,
              source: r.source,
              range_min: r.min,
              range_max: r.max,
              range_index: i
            };
          }
        }
      }
    }
    return null;
  }

  function getSupplierModifierName(source) {
    if (!source) return "";
    const m = source.match(/supplier modifier:\s*([^;]+)/i);
    return m ? m[1].trim() : "";
  }

  function isInStockMadeToOrderSupplier(source) {
    const name = getSupplierModifierName(source).toLowerCase();
    if (name.indexOf("heritage") === 0) return true;
    if (name.indexOf("heritage") !== -1) return true;
    return false;
  }

  function getDispatchStateAndMessage(resolved, qty) {
    if (!resolved) return { state: "none", message: "" };

    const srcOriginal = resolved.source || "";
    const src = srcOriginal.toLowerCase();

    const hasSupplierModifier = src.indexOf("supplier modifier") !== -1;
    const isHeritageMTO = isInStockMadeToOrderSupplier(srcOriginal);
    const isOiled = src.indexOf("sku pattern 'oiled'") !== -1 || src.indexOf('sku pattern "oiled"') !== -1;

    // Heritage message
    if (isHeritageMTO) {
      return {
        state: "mto",
        message: "Made To Order - Est Dispatch " + formatDateWithOrdinal(resolved.date)
      };
    }

    // OILED: show Pre-order until ETA is within X days, then show "Ready to Oil" message
    if (isOiled && resolved.range_index === 0 && !hasSupplierModifier) {
      const deltaDays = daysFromTodayUTC(resolved.date);
      if (deltaDays == null || deltaDays > OILED_SWITCH_TO_MESSAGE_DAYS) {
        return { state: "preorder", message: preorderMessage(resolved.date) };
      }

      const formatted = formatDateWithOrdinal(resolved.date);

      if (resolved.range_min != null && resolved.range_max != null) {
        const bandWidth = (resolved.range_max - resolved.range_min) + 1;

        if (bandWidth <= LOW_STOCK_BUFFER) {
          return { state: "oiled", message: "Low Stock - Oiled Finish - Est Dispatch " + formatted };
        }

        if (bandWidth >= LOW_STOCK_MIN_BAND_WIDTH) {
          const lowStockCutoff = (resolved.range_max - LOW_STOCK_BUFFER) + 1;
          if (qty >= lowStockCutoff) {
            return { state: "oiled", message: "Low Stock - Oiled Finish - Est Dispatch " + formatted };
          }
        }
      }

      return { state: "oiled", message: "In Stock Ready To Oil - Est Dispatch " + formatted };
    }

    // Rule 1: band 1+ => Pre-order (WITH DATE)
    if (resolved.range_index != null && resolved.range_index > 0) {
      return { state: "preorder", message: preorderMessage(resolved.date) };
    }

    // Rule 2: supplier lead-time => Pre-order (WITH DATE)
    if (hasSupplierModifier) {
      return { state: "preorder", message: preorderMessage(resolved.date) };
    }

    // Rule 3: band 0 can only be "In Stock" if ETA is within the window (WORKING DAYS)
    if (resolved.range_index === 0) {
      const bizDays = businessDaysFromTodayUTC(resolved.date);

      // If we can't parse date safely, do not risk false "In Stock"
      if (bizDays == null) {
        return { state: "preorder", message: preorderMessage(resolved.date) };
      }

      // If ETA is too far out (in WORKING days), treat as Pre-order until it comes within range
      if (bizDays > IN_STOCK_DAY_WINDOW) {
        return { state: "preorder", message: preorderMessage(resolved.date) };
      }

      // Otherwise In Stock / Low Stock logic
      if (resolved.range_min != null && resolved.range_max != null) {
        const bandWidth = (resolved.range_max - resolved.range_min) + 1;

        if (bandWidth <= LOW_STOCK_BUFFER) {
          return { state: "lowstock", message: "Low Stock - Running Low" };
        }

        if (bandWidth >= LOW_STOCK_MIN_BAND_WIDTH) {
          const lowStockCutoff = (resolved.range_max - LOW_STOCK_BUFFER) + 1;
          if (qty >= lowStockCutoff) {
            return { state: "lowstock", message: "Low Stock - Running Low" };
          }
        }
      }

      return { state: "instock", message: "In Stock & Ready To Ship" };
    }

    return { state: "preorder", message: preorderMessage(resolved.date) };
  }

  function clearDisplay() {
    etaDisplayTarget.innerHTML = "";
  }

  function updateETA() {
    const variantId = variantInput.value;
    const qty = parseInt(quantityInput.value, 10);

    if (isNaN(qty) || qty < 1) {
      clearDisplay();
      return;
    }

    const resolved = resolveETA(variantId, qty);

    if (!resolved) {
      clearDisplay();
      return;
    }

    const result = getDispatchStateAndMessage(resolved, qty);

    // If the result message displays a past date, show "Call Us For Details" instead
    if (resolved.date && isDateInPast(resolved.date) && window.__enableCallUsForDetails) {
      const formattedDate = formatDateWithOrdinal(resolved.date);
      if (formattedDate && result.message && result.message.indexOf(formattedDate) !== -1) {
        etaDisplayTarget.innerHTML = renderInventoryStatusHTML('Est. Dispatch: Call Us For Details', 'callus');
        return;
      }
    }

    if (!result.message) {
      clearDisplay();
      return;
    }

    etaDisplayTarget.innerHTML = renderInventoryStatusHTML(result.message, result.state);
  }

  updateETA();

  variantInput.addEventListener('change', function () {
    setTimeout(updateETA, 50);
  });

  window.addEventListener('quantity-changed', function () {
    updateETA();
  });

  window.addEventListener('cart-drawer:updated', function () {
    const variantId = variantInput.value;

    let rawEntry = null;
    for (const sku in metafieldRaw) {
      const entry = metafieldRaw[sku];
      if (entry && entry.variant_id == variantId) {
        rawEntry = entry;
        break;
      }
    }
    if (!rawEntry) return;

    const rawEtaArray = JSON.parse(localStorage.getItem('rawEta')) || [];
    const updatedEtaArray = rawEtaArray.filter(item => item.variant_id !== rawEntry.variant_id);
    updatedEtaArray.push(rawEntry);
    localStorage.setItem('rawEta', JSON.stringify(updatedEtaArray));
  });
});